import React, { useEffect, useState } from "react";
import { FetchFile } from "./FetchFile";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUndo, faRedo } from "@fortawesome/free-solid-svg-icons";

const Image = ({ file }) => {
  const [zoom, setZoom] = useState(1);
  const [imageUrl, setImageUrl] = useState(null);
  const [rotation, setRotation] = useState(0);

  useEffect(() => {
    if (file) {
      FetchFile(file, setImageUrl);
    }
  }, [file]);

  const zoomIn = () => {
    setZoom((prevZoom) => prevZoom + 0.1, 3);
  };

  const zoomOut = () => {
    setZoom((prevZoom) => Math.max(prevZoom - 0.1, 1));
  };

  const rotateLeft = () => {
    setRotation((prevRotation) => prevRotation - 90);
  };

  const rotateRight = () => {
    setRotation((prevRotation) => prevRotation + 90);
  };

  return (
    <>
      <div
        style={{
          width: "100%",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            width: "100%",
            height: "80%",
            overflow: "auto",
            position: "relative",
          }}
        >
          <iframe
            srcDoc={`<html><body style="margin:0; display:flex; justify-content:center; align-items:center;">
                    <img src="${imageUrl}" style="transform: scale(${zoom}) rotate(${rotation}deg); transform-origin: center center; width:auto; height:auto; max-width: 100%; max-height: 100%;" />
                   </body></html>`}
            title="Image Viewer"
            width="100%"
            height="100%"
            style={{ border: "none", position: "absolute", top: 0, left: 0 }}
          />
        </div>
        <div style={{ marginTop: "10px" }}>
          <button
            className="btn btn-link"
            onClick={rotateLeft}
            style={{ fontSize: "30px" }}
          >
            <FontAwesomeIcon icon={faUndo} />
          </button>
          <button className="btn btn-primary" onClick={zoomIn}>
            Zoom In
          </button>
          <button className="btn btn-primary ms-3" onClick={zoomOut}>
            Zoom Out
          </button>

          <button
            className="btn btn-link"
            style={{ fontSize: "30px" }}
            onClick={rotateRight}
          >
            <FontAwesomeIcon icon={faRedo} />
          </button>
        </div>
      </div>
    </>
  );
};

export default Image;
